export type Lang = 'zh-CN' | 'en-US'

export const LANG_MAP = [
  {
    label: '中文',
    value: 'zh-CN',
  },
  {
    label: 'English',
    value: 'en-US',
  },
]
